import { Drawing } from "drawing";

export function dwgShape() {
  return [
    [
      { x: -7, y: -7 },
      { x: 7, y: -7 },
    ],
    [
      { x: -5, y: -5 },
      { x: -3, y: -5 },
      { x: 6, y: 4 },
      { x: 4, y: 6 },
      { x: -5, y: -3 },
      { x: -5, y: -5 },
    ],
  ];
}

export function drawingSymbol(locId, pos, highlighted) {
  const shapes = dwgShape();
  const [outline, ...interior] = shapes;

  const stroke = highlighted ? "white" : "black";
  const fill = highlighted ? "black" : "white";

  return new Drawing()
    .symbol(
      [
        { type: "polyface", faces: [outline] },
        ...interior.map((s) => ({ type: "polyline", vertices: s })),
      ],
      pos,
      { offset: { x: -20, y: -15 } },
    )
    .style({ stroke, fill })
    .name(`editbtn_${locId}`);
}

export default drawingSymbol;
